import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Form } from 'react-bootstrap';
import FadeIn from 'react-fade-in/lib/FadeIn';
import { AddressCard } from './address-card';
import { layoutDefaults } from '../../utils/layout-defaults';

function AddressComplementModalBody({
  placeDetails,
  baseLocation,
  noStreetNumber,
  config,
  complement: pComplement,
  onComplementChange,
}) {
  const [complement, setComplement] = useState(pComplement);
  const classes = useStyles();

  useEffect(() => {
    onComplementChange?.call(this, complement);
  }, [complement]);

  const handleOnComplementChange = (event) => {
    setComplement(event.target.value);
  };

  return (
    <div className={classes.container}>
      <AddressCard
        config={config}
        placeDetails={placeDetails}
        baseLocation={baseLocation}
        noStreetNumber={noStreetNumber}
      />
      <FadeIn delay={layoutDefaults.keyboardDuration}>
        <Form>
          <div className={classes.label}>Informe o complemento:</div>
          <Form.Control
            className={classes.textarea}
            as="textarea"
            type="textarea"
            value={complement}
            placeholder="Apartamento, sala, condomínio, referência, etc."
            onChange={handleOnComplementChange}
            maxLength={50}
            // defaultValue={parseMapComplement(placeDetails)}
            // defaultValue={parseMapComplement(placeDetails)}
          />
        </Form>
      </FadeIn>

      {/* <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>JSON</Accordion.Header>
          <Accordion.Body>
            <pre>{JSON.stringify(placeDetails, null, '  ')}</pre>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion> */}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // fontSize: 11,
    textAlign: 'left',
    marginTop: -layoutDefaults.verticalMargin,

    // border: '1px solid red',
  },
  label: {
    color: layoutDefaults.primaryColor,
    display: 'flex',
    // alignSelf: 'left',
    fontSize: layoutDefaults.bigFontSize,
    marginTop: layoutDefaults.biggerVerticalMargin,
    // border: '1px solid red',
  },
  textarea: {
    height: 100,
  },
});

export { AddressComplementModalBody };
